import { Component, inject } from '@angular/core';
import { ModalService } from '../../../services/modal.service';
import { CommonModule } from '@angular/common';
import { InputFieldComponent } from '../../form/input/input-field.component';
import { ButtonComponent } from '../../ui/button/button.component';
import { LabelComponent } from '../../form/label/label.component';
import { ModalComponent } from '../../ui/modal/modal.component';
import { AuthService, CurrentUser } from '../../../services/auth.service';

@Component({
  selector: 'app-user-info-card',
  imports: [
    CommonModule,
    InputFieldComponent,
    ButtonComponent,
    LabelComponent,
    ModalComponent,
  ],
  templateUrl: './user-info-card.component.html',
  styles: ``
})
export class UserInfoCardComponent {

  constructor(public modal: ModalService) {}

  private auth = inject(AuthService);

  isOpen = false;
  openModal() { this.isOpen = true; }
  closeModal() { this.isOpen = false; }

  user = {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    bio: '',
    social: {
      facebook: '',
      x: '',
      linkedin: '',
      instagram: '',
    },
  };

  private mapFromCurrentUser(u: CurrentUser | null) {
    const username = u?.username ?? '';
    const parts = username.split(' ').filter(Boolean);
    const firstName = parts[0] ?? username;
    const lastName = parts.slice(1).join(' ');
    this.user.firstName = firstName;
    this.user.lastName = lastName;
    this.user.email = u?.email ?? '';
    // phone, bio, social remain as empty unless your backend provides them
  }

  ngOnInit() {
    this.auth.user$.subscribe(u => this.mapFromCurrentUser(u));
  }

  handleSave() {
    // Handle save logic here
    console.log('Saving changes...');
    this.modal.closeModal();
  }
}
